import { css } from '@emotion/react'
import AppBreadcrumbs from 'gatsby-theme-marketplace-base/src/components/Product/Breadcrumbs'

const breadcrumbsCss = css`
  height: 0;
  width: none;
  border: none;
`

export default (props) => <AppBreadcrumbs {...props} css={breadcrumbsCss} />
